/**
 * BriefingA2.jsx — Wrapper de la route /briefing-a2 (moto A2 puissante).
 * Pas de poster visuel ici — le contenu est 100% textuel (branches + QCM).
 */
import React from 'react';
import BriefingPage from '../components/BriefingPage';
import { briefing, briefingQuiz } from '../data/briefingA2';

export default function BriefingA2() {
  return <BriefingPage briefing={briefing} briefingQuiz={briefingQuiz} heroEmoji="🏁" />;
}
